import MapElement from './MapElement';
import MapDiagnosticsDots from './MapDiagnosticsDots';
import mapDiagnosticsMachine from './MapDiagnosticsMachine';
import LayerGroup from 'ol/layer/Group';

export default class MapDiagnostics extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent)

        this.dotsElement;
        this.machineElement;
    }

    drawLayer(data, projection) {
        this.removeLayer()
        this.clear();

        this.layer = new LayerGroup();
        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }

        if (!this.dotsElement) {
            this.dotsElement = new MapDiagnosticsDots(this.mapModel, "DIAGNOSTICSDOTS",
                {
                    interactable: this.mapElementSettings.interactable,
                    group: true,
                    defaultOn: this.mapElementSettings.defaultOn,
                    actions: this.mapElementSettings.actions
                },
                this);
            this.mapElements.push(this.dotsElement);
        }
        if (!this.machineElement) {
            this.machineElement = new mapDiagnosticsMachine(this.mapModel, "DIAGNOSTICSMACHINE",
                {
                    interactable: this.mapElementSettings.interactable,
                    group: true,
                    defaultOn: this.mapElementSettings.defaultOn,
                    actions: this.mapElementSettings.actions
                },
                this);
            this.mapElements.push(this.machineElement);
        }

        this.dotsElement.drawLayer(data, projection);
        this.machineElement.drawLayer(data, projection);

        this.mapModel.map.addLayer(this.layer);

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }
}